import { createMutationHook } from '~/shared/providers/api';

export const useUpdateFreightLaneCostMutation = createMutationHook(
  'transportation.freightLaneCostUpdate',
  (params: {
    id: string;
    startDate?: string;
    endDate?: string | null;
    rateFormula?: string;
    rateVariableIds?: string | null;
    minimumChargeAmount?: string | null;
    minimumChargeCurrencyCode?: string | null;
    chargebackFormula?: string | null;
    chargebackVariableIds?: string | null;
    minimumChargebackAmount?: string | null;
    minimumChargebackCurrencyCode?: string | null;
    fuelSurchargeFormula?: string | null;
    fuelSurchargeVariableIds?: string | null;
    fuelSurchargeMode?: string | null;
    currency?: string;
  }) => ({
    transportationFreightLaneCostUpdate: {
      __args: {
        id: params.id,
        input: {
          startDate: params.startDate,
          endDate: params.endDate,
          rateFormula: params.rateFormula,
          rateVariableIds: params.rateVariableIds,
          minimumChargeAmount:
            params.minimumChargeAmount !== undefined
              ? params.minimumChargeAmount !== null
                ? Number(params.minimumChargeAmount)
                : null
              : undefined,
          minimumChargeCurrencyCode: params.minimumChargeCurrencyCode,
          chargebackFormula: params.chargebackFormula,
          chargebackVariableIds: params.chargebackVariableIds,
          minimumChargebackAmount:
            params.minimumChargebackAmount !== undefined
              ? params.minimumChargebackAmount !== null
                ? Number(params.minimumChargebackAmount)
                : null
              : undefined,
          minimumChargebackCurrencyCode: params.minimumChargebackCurrencyCode,
          fuelSurchargeFormula: params.fuelSurchargeFormula,
          fuelSurchargeVariableIds: params.fuelSurchargeVariableIds,
          fuelSurchargeMode: params.fuelSurchargeMode,
          currency: params.currency,
        },
      },
      id: true,
      freightLaneId: true,
      startDate: true,
      endDate: true,
      rateFormula: true,
      currency: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
